import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { Router } from '@angular/router';
import { AdministratorService } from '../../../services/administrator.service';
import { CommonModule } from '@angular/common';
import { ApiResponse, gridPageRequest, userRolesList } from '../../../model/common/common.model';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-role-list',
  standalone: true,
  imports: [SharedModule,CommonModule],
  templateUrl: './role-list.component.html',
  styleUrl: './role-list.component.scss'
})
export class RoleListComponent implements OnInit {

  constructor(private router:Router , private administratorService:AdministratorService, private messageService:MessageService){}
  @ViewChild('dt1') dt1: Table | undefined;
  roleList: userRolesList[] = [];
  RoleId:string ='';
  isActive:boolean = false;
  searchKey : any;

 pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 50,
    id: 0
  }
  ngOnInit(): void {
    document.title = 'Roles List';
    this.getAllRoles();
    this.searchEffect();
    }

    roleData:any;
  SelectOption(event: any) {
    if(event?.data){
      this.RoleId = event.data.roleId;
      this.roleData = event.data;
      if(event.data.isActive){
        this.isActive = false;
      }else{
        this.isActive = true;
      }
    }else{
      this.RoleId = '';
    }
  }



  createRole(){
    this.router.navigate(['/home/createRoles']);
  }

  getAllRoles(){
    this.administratorService.getAllRoles().subscribe({
      next: data => {
        // this.roleList = JSON.parse(data as string) as userRolesList[];
        this.roleList = data as userRolesList[];
      },
      error: error => {
        console.log(error);
      }
    })
  }


  deleteRoles(){
    this.administratorService.deleteRole(this.RoleId,this.isActive).subscribe({
      next: data => {
        let response ={
          message:''
        }
        this.RoleId = '';
        this.getAllRoles();
        response = data as ApiResponse;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });

      },
      error: error => {
        console.log(error);
      }
    })
  }


  editRoles() {
    const roleDataString = JSON.stringify(this.roleData);
    this.router.navigate(['/home/createRoles'], {queryParams: { 'roleData': roleDataString },skipLocationChange: true,});
  }

  searchRole() {
    if (!this.searchKey) {
      return;
    }
    this.administratorService.autoSearchRole(this.searchKey).subscribe(
      (data: any) => {
        if (data) {
          this.roleList = data;
          if (this.dt1) {
            this.dt1.first = 0;
          }
        } else {
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
  

refreshData(): void {
  if (this.dt1) {
    this.dt1.first = 0; 
    this.dt1.clear();
  }
  this.searchKey = '';
  this.getAllRoles();
}

loadRoles(event:any){
  if (this.searchKey && this.searchKey.trim() !== '') {
    this.searchRole();
  } else {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getAllRoles();
  }
}

  placeholder: string = 'Search By ';
  private messages: string[] = ['Role Name', 'Description'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

}

